import React, { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { renderGoogleWebButton } from '../lib/webIdentity';

// Google's own rendered button (required by Google Identity Services on web).
export const GoogleWebButton = ({ onCredential, text = 'continue_with', testId = 'google-web-btn' }) => {
  const ref = useRef(null);
  const cb = useRef(onCredential);
  cb.current = onCredential;

  useEffect(() => {
    if (!ref.current) return;
    renderGoogleWebButton(ref.current, (cred) => cb.current(cred), text)
      .catch((e) => toast.error(e.message));
  }, [text]);

  return <div ref={ref} className="w-full flex justify-center min-h-[44px]" data-testid={testId} />;
};

export default GoogleWebButton;
